import { render, staticRenderFns } from "./manager-list.vue?vue&type=template&id=6c2ba503"
import script from "./manager-list.vue?vue&type=script&lang=js"
export * from "./manager-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports